import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import axios from "axios";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material components
import MDTypography from "components/MDTypography";
import MDLoading from "components/MDLoading/MDLoading";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDBox from "components/MDBox";

// Material example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

// ICONS
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

function Areas() {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const auth = localStorage.getItem("authToken");
    const user_id = localStorage.getItem("user_id");

    const [loading, setLoading] = useState(false);

    const [deleteLoading, setDeleteLoading] = useState(false);

    const [allAreas, setAllAreas] = useState([])
    const [allAreasRowData, setAllAreasRowData] = useState([])

    // Edit
    const [openDialog, setOpenDialog] = useState(false);
    const [editLoading, setEditLoading] = useState(false);
    const [dialogEditData, setDialogEditData] = useState({ area_id: '', area_name: '', user_id: '' });

    useEffect(() => {
        fetchAllAreas();
    }, [])

    const fetchAllAreas = async () => {
        setLoading(true);
        await axios.post(`${process.env.REACT_APP_BASEURL}/admin/areas/all`, { user_id }, {
            headers: { Authorization: `Bearer ${auth}` }
        })
            .then(res => {
                if (!res.data?.success) return enqueueSnackbar('Error Fetching Areas !!!', { variant: 'error' })

                createTableRowData(res.data.areas);
                setAllAreas(res.data.areas);
                setLoading(false);
            })
            .catch(err => {
                console.log(err);
                setLoading(false);
                enqueueSnackbar('Error Fetching Areas !!!', { variant: 'error' })
            })
    }

    const createTableRowData = (usersArr) => {
        const rowDataObjArr = [];

        usersArr?.forEach(a => {
            rowDataObjArr.push({
                area_name: (
                    <MDTypography display="block" variant="h6" fontWeight="medium" color="black" >
                        {a?.area_name}
                    </MDTypography>
                )
            })
        })

        setAllAreasRowData(rowDataObjArr);
    }

    const onDeleteClick = async (rowData) => {
        setDeleteLoading(true);

        const body = { area_id: allAreas[rowData?.row?.index]?.area_id, user_id }

        await axios.post(`${process.env.REACT_APP_BASEURL}/admin/areas/delete`, body, {
            headers: { Authorization: `Bearer ${auth}` }
        })
            .then(res => {
                if (res.data?.success) {
                    enqueueSnackbar('Area Deleted Successfully !!!', { variant: 'success' })
                    const allAreasNew = [...allAreas];
                    allAreasNew.splice(rowData?.row?.index, 1);

                    const allUsersRowDataNew = [...allAreasRowData]
                    allUsersRowDataNew.splice(rowData?.row?.index, 1);

                    setAllAreas(allAreasNew);
                    setAllAreasRowData(allUsersRowDataNew);
                } else {
                    enqueueSnackbar(res.data?.message, { variant: 'error' })
                }
                setDeleteLoading(false);
            })
            .catch(err => {
                console.log(err);
                setDeleteLoading(false);
                enqueueSnackbar('Error Deleting Area !!!', { variant: 'error' })
            })
    }

    const onEditClick = (rowData) => {
        setOpenDialog(true)
        setDialogEditData({ ...allAreas[rowData?.row?.index] })
    }

    const onCloseDialog = (e, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
        setOpenDialog(false);
    };

    const onUpdate = async () => {
        const body = { ...dialogEditData }
        setEditLoading(true)

        await axios.put(`${process.env.REACT_APP_BASEURL}/admin/areas/update`, body, {
            headers: { Authorization: `Bearer ${auth}` }
        })
            .then(res => {
                if (res.data?.success) {
                    const updateIndex = allAreas?.findIndex(u => u.area_id === body.area_id)
                    if (updateIndex === -1) return enqueueSnackbar('Error Area Not Found !!!', { variant: 'error' })

                    const allAreaArrTemp = [...allAreas];
                    allAreaArrTemp[updateIndex] = body;

                    setAllAreas(allAreaArrTemp);
                    createTableRowData(allAreaArrTemp);
                    enqueueSnackbar('Area Updated Successfully !!!', { variant: 'success' })
                } else {
                    enqueueSnackbar('Error Updating Area !!!', { variant: 'error' })
                }

                setOpenDialog(false);
                setEditLoading(false);
            })
            .catch(err => {
                console.log(err);
                setLoading(false);
                setEditLoading(false);
                enqueueSnackbar('Error Updating Area !!!', { variant: 'error' })
            })
    }

    const columns = [
        { Header: "Area Name", accessor: "area_name", align: "left" },
        {
            Header: "Action",
            accessor: "action",
            align: "center",
            width: '10%',
            Cell: (row) => (
                <div>
                    <MDButton onClick={(e) => onDeleteClick(row)} variant="gradient" color="info" style={{ minWidth: 'unset', padding: '2px 12px' }} >
                        <DeleteIcon />
                    </MDButton >

                    <MDButton onClick={(e) => onEditClick(row)} variant="gradient" color="info" iconOnly sx={{ marginLeft: 1 }} >
                        <EditIcon />
                    </MDButton>
                </div >
            ),
        },
    ]
    return (
        <DashboardLayout>
            <DashboardNavbar hidebreadcrumbTitle />
            <MDBox pt={3} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info"
                                borderRadius="lg" coloredShadow="info"
                            >
                                <Grid container direction="row" justifyContent="space-between" alignItems="center">
                                    <MDTypography variant="h6" color="white">
                                        Areas
                                    </MDTypography>

                                    <MDBox className="admin_btnsHeaderCont">
                                        <MDButton onClick={() => navigate('/areas/create')} variant="outlined" color="white">
                                            Add Area
                                        </MDButton>
                                    </MDBox>
                                </Grid>
                            </MDBox>
                            <MDBox pt={3}>
                                {loading ? (
                                    <CircularProgress sx={{ display: 'block', color: '#49a3f1', margin: '0 auto 20px' }} />
                                ) : (
                                    <DataTable
                                        table={{ columns, rows: allAreasRowData }}
                                        isSorted={false}
                                        entriesPerPage={false}
                                        showTotalEntries={false}
                                        noEndBorder
                                    />
                                )}
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>

            <MDLoading open={deleteLoading} />

            <Dialog fullWidth maxWidth='md' open={openDialog} onClose={onCloseDialog} >
                <DialogTitle sx={{ color: '#000' }} >Update Area</DialogTitle>
                <DialogContent>
                    <MDInput type="text" label="Area Name" value={dialogEditData.area_name} name="area_name" margin="dense"
                        fullWidth onChange={(e) => setDialogEditData({ ...dialogEditData, area_name: e.target.value })}
                    />
                </DialogContent>
                <DialogActions>
                    <MDButton variant="outlined" color="info" onClick={onCloseDialog} disabled={editLoading} >
                        Close
                    </MDButton>
                    <MDButton variant="gradient" onClick={onUpdate} style={{ backgroundColor: 'darkgreen', color: '#fff' }} disabled={editLoading} >
                        Update
                    </MDButton>
                </DialogActions>
            </Dialog>

        </DashboardLayout>
    );
}

export default Areas;
